// extracted by mini-css-extract-plugin
export default {"addressColumn":"address-column_addressColumn__-76lC"};